export enum ClaimOTPType {
  UPDATE_PROFILE = 'UPDATE_PROFILE',
  CHANGE_EMAIL = 'CHANGE_EMAIL',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  LOGIN = 'LOGIN',
  ENABLE_MFA = 'ENABLE_MFA',
  DISABLE_MFA = 'DISABLE_MFA',
  UPDATE_MFA = 'UPDATE_MFA',
  LOGOUT = 'LOGOUT',
}

export enum SaveUserProfile {
  ProfileDetails,
  Email,
  Password,
  MFA,
  Logout,
}

export enum LoginSessionLogType {
  LOGIN = 'LOGIN',
  SEARCH = 'SEARCH',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  INSERT = 'INSERT',
  UPLOAD = 'UPLOAD',
  DOWNLOAD = 'DOWNLOAD',
}

export enum TokenExpiredType {
  ACCESS = 'ACCESS',
  REFRESH = 'REFRESH',
  TEMPORARY = 'TEMPORARY',
  OTP = 'OTP',
  MFA = 'MFA',
  INVITE_MEMBER = 'INVITE_MEMBER',
  IMS_MERCHANT_DETAIL = 'IMS_MERCHANT_DETAIL',
}

export enum ChangeEmailFlow {
  MODAL_MFA = 'MODAL_MFA',
  MODAL_CONFIRMATION_1 = 'MODAL_CONFIRMATION_1',
  MODAL_EDIT_EMAIL = 'MODAL_EDIT_EMAIL',
  MODAL_CONFIRMATION_2 = 'MODAL_CONFIRMATION_2',
  MODAL_OTP = 'MODAL_OTP',
  MODAL_SUCCESS = 'MODAL_SUCCESS',
}

export enum ChangePasswordFlow {
  MODAL_MFA = 'MODAL_MFA',
  MODAL_CONFIRMATION_1 = 'MODAL_CONFIRMATION_1',
  MODAL_OTP = 'MODAL_OTP',
  MODAL_EDIT_PASSWORD = 'MODAL_EDIT_PASSWORD',
  MODAL_CONFIRMATION_2 = 'MODAL_CONFIRMATION_2',
  MODAL_SUCCESS = 'MODAL_SUCCESS',
}
